//Quiz last step
class QuizPdpStepPage extends HTMLElement {
	constructor() {
		super();
		//diet options data
		this.dietOptions = {
			healthIssue: {
				wood: ["Sensitive stomach", "Liver support", "Seizures"],
				fire: [
					"Pancreatitis",
					"Cushings",
					"Environmental skin allergies",
					"Anxiety",
				],
				earth: ["Obesity", "Cancer remission"],
				metal: ["Weight gain", "Cancer treatment", "Diabetes"],
				water: [
					"Inflammatory Bowel Disease",
					"Food allergies",
					"Kidney support",
					"Arthritis and hind leg weakness",
				],
			},
			healthy: {
				wood: [
					"Gentle diet for a sensitive stomach",
					"Gentle diet for a puppy",
				],
				fire: ["Anti-inflammatory", "Lean meat"],
				earth: ["Light and low fat diet", "Vegetarian"],
				metal: ["Improve body and skin dryness", "Hearty meal"],
				water: ["Hypoallergenic", "Picky eaters"],
			},
			totalDiet: ["fire", "water"],
			dietData: {
				fire: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/image_75.png?v=1755154478",
					halfImage:
						"https://cdn.shopify.com/s/files/1/0550/7543/8658/files/istockphoto-486932107-612x612_1_1.png?v=1738904948",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/fire-icon.svg",
					items: ["Turkey", "Pumpkin", "Broccoli"],
					description:
						"Fire Diet is an anti-inflammatory diet to protect against chronic inflammatory disease.",
				},
				water: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/image_74.png?v=1755154445",
					halfImage:
						"https://cdn.shopify.com/s/files/1/0550/7543/8658/files/istockphoto-486932107-612x612_1_1.png?v=1738904948",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/Vector_4.png?v=1671020967",
					items: ["Pork", "Green beans", "Sweet Potato"],
					description:
						"Water Diet is a hypoallergenic, kidney supportive diet.",
				},
			},
		};

		//Selected custom diet
		this.customDietSelected = [];

		//get selected variant
		var menuPdpSelection = localStorage.getItem("menuPdpSelection");
		this.menuPdpSelection =
			(menuPdpSelection && JSON.parse(menuPdpSelection)) || [];

		// alert(this.menuPdpSelection);

		// Update selected options
		this.updateSelections();

		//variant options
		this.variants = this.querySelectorAll(
			".diet-info-col .check-box input"
		);

		//all step qualifying
		this.filterDietOptions();

		//dispatch eventsTarget
		this.dispatchEventHandler();

		// Wait and add rc widget
		this.waitForRcWidget();
	}
	/**
	 * pure functions
	 */
	// live click method
	_liveClickMethod(selector, event, callback, context) {
		// helper for enabling IE 8 event bindings
		function addEvent(el, type, handler) {
			if (el.attachEvent) el.attachEvent("on" + type, handler);
			else el.addEventListener(type, handler);
		}
		// matches polyfill
		this &&
			this.Element &&
			(function (ElementPrototype) {
				ElementPrototype.matches =
					ElementPrototype.matches ||
					ElementPrototype.matchesSelector ||
					ElementPrototype.webkitMatchesSelector ||
					ElementPrototype.msMatchesSelector ||
					function (selector) {
						var node = this,
							nodes = (
								node.parentNode || node.document
							).querySelectorAll(selector),
							i = -1;
						while (nodes[++i] && nodes[i] != node);
						return !!nodes[i];
					};
			})(Element.prototype);
		// live binding helper using matchesSelector
		function _liveClickMethod(selector, event, callback, context) {
			addEvent(context || document, event, function (e) {
				var found,
					el = e.target || e.srcElement;
				while (
					el &&
					el.matches &&
					el !== context &&
					!(found = el.matches(selector))
				)
					el = el.parentElement;
				if (found) callback.call(el, e);
			});
		}
		_liveClickMethod(selector, event, callback, context);
	}
	//remove class
	removeClass(selector, cls) {
		var el = document.querySelectorAll(selector);
		if (el.length > 0) {
			el.forEach(function (item) {
				item.classList.contains(cls) && item.classList.remove(cls);
			});
		}
	}
	//add Class
	addClass(selector, cls) {
		var el = document.querySelector(selector);
		if (el) {
			el.classList.add(cls);
		}
	}

	// Update menu pdpd selection based on url
	updateSelections() {
		var pageLoc = window.location.href;
		if (pageLoc.includes("/products/chicat-water-diet")) {
			this.menuPdpSelection = ["water"];
		} else if (pageLoc.includes("/products/chicat-fire-diet")) {
			this.menuPdpSelection = ["fire"];
		}
	}

	//wait for rc widgets
	waitForRcWidget() {
		var _this = this;
		var interval = setInterval(function () {
			if (typeof window.ReChargeWidget != "undefined") {
				clearInterval(interval);
				_this.generateRcWidget();
			}
		}, 50);
		setTimeout(function () {
			clearInterval(interval);
		}, 25000);
	}
	getSelectedData() {
		let diet = jQuery(
			".product-meal-plan-right.active-meal_form:visible"
		).attr("target-prod");
		// Get the value of data-weeks from the selected delivery button
		let frequency = jQuery(".delivery-button.selected-option:visible").data(
			"weeks"
		);

		// Get the value of the visible dropdown in the product form
		let weight = jQuery(
			".product-form__input--dropdown .select__select:visible"
		).val();

		// Return the values in an array
		return { diet, frequency, weight };
	}
	// Add rc widget
	generateRcWidget() {
		var rcWidgets = document.querySelectorAll(
			".product-meal-plan-right form[formid]"
		);
		rcWidgets.length > 0 &&
			rcWidgets.forEach(function (widget) {
				var prodId = widget.getAttribute("formid");
				if (prodId) {
					prodId = parseInt(prodId);
					var config = {
						productId: prodId,
						injectionParent:
							'form[action*="cart/add"][formid="' + prodId + '"]',
						injectionMethod: "prepend",
						injectFn: (node, target) => {},
						selectors: {
							// price: ['.my-price-selector'],
							variant: [
								'.product-form__input--dropdown .select__select[form="product-form-' +
									prodId +
									'"]',
							],
						},
					};
					window.ReChargeWidget.createWidget(config);
				}
			});
	}

	/**
	 *
	 * @param {String} diet
	 * @param {String} type
	 * @param {Number} index
	 * @param {Object} dietOptionsDesc
	 * @returns
	 */
	buildDietVariant(diet, type, index) {
		var checkedDiet = "";
		//if type description
		if (type == "recommend") {
			checkedDiet = "checked";
		}

		//active diet variant
		if (index == 0) {
			//active diet detail
			var activeDiet = document.querySelector(
				"#product-right-content .product-diet-row.product-diet-active"
			);
			var newActiveDiet = document.querySelector(
				`#product-right-content .product-diet-row[data-type='${diet}']`
			);
			activeDiet && activeDiet.classList.remove("product-diet-active");
			newActiveDiet && newActiveDiet.classList.add("product-diet-active");
		}

		//diet data change
		var data = this.dietOptions.dietData[`${diet}`];
		var dietList = "";

		if (data) {
			data.items &&
				data.items.forEach(function (item) {
					dietList += `<li>${item}<span class="diet_listMobile">/</span></li>`;
				});

			if (diet == "bag") {
				var html = "";
			} else {
				var html = `
        <div class="diet-box-1 variety-box" diet-type="${diet}">
            <div class="diet-info-box">
              <div class="diet-info-wrapper">
              <div class="diet-info-row">
                <div class="diet-info-col">
                  <div class="diet-img 1 newHalfOrder">
                    <div class="line" style=""></div>
                      <img class="halfImage" src="${data.halfImage}" alt="${diet}">
                      <img class="mainImage" src="${data.image}" alt="${diet}">
                  </div>
                </div>
                <div class="diet-info-col diet-info-col-right">
                  <div class="diet-name-log">
                    <div class="logo"><img src="${data.icon}" alt=""></div>
                    <h2>${diet} Diet</h2>
                  </div>
                  <ul class="diet">${dietList}</ul>
                </div>
              </div>
              <p class="diet-info-desc">${data.description}</p>
              </div>
              <div class="diet-info-row diet-info-row-bottom">
                <div class="diet-info-col">
                  <label class="check-box" for="${diet}-diet">
                    <input type="checkbox" id="${diet}-diet" name="${diet}" ${checkedDiet} isrecommend="${type}">
                    <span class="plan-needtoAdd">Add to Meal Plan</span>
                    <span class="plan-added">Added</span>
                  </label>
                </div>
                <div class="diet-info-col">
                  <div class="diet-detail-button" modal-id="${diet}"><span class="plan-needtoAdd-2">Learn more &nbsp;</span><span class="plan-added-2">Learn more about the ${diet} diet &nbsp;</span><img src="https://cdn.shopify.com/s/files/1/0550/7543/8658/files/Vector_10.png?v=1674021566"
                  alt="Vector-10"/>
                  </div>
                </div>
              </div>
              
            </div>
        </div>`;
			}
		} else {
			return "";
		}

		return html;
	}
	//recommended diet
	getVariantSection(diets, type) {
		var html = "",
			_this = this;
		if (type == "recommend") {
			diets.forEach(function (diet, i) {
				html += _this.buildDietVariant(diet, "recommend", i);
			});
		} else {
			diets.forEach(function (diet) {
				html += _this.buildDietVariant(diet);
			});
		}

		return html;
	}

	/**
	 * build custom diet nav
	 */
	buildCutomMealNav() {
		var html = "",
			_this = this;
		var customNavBuild = [];
		console.log(this.customDietSelected);
		console.log(_this.dietOptions);
		this.customDietSelected.forEach(function (diets) {
			var data = _this.dietOptions.dietData[`${diets.diet}`];
			if (!customNavBuild.includes(diets.diet)) {
				customNavBuild.push(diets.diet);
				html += `
        <li class="chidog-dite-img ${
			diets.isSelected == true ? "active-diet-opt" : ""
		}" diet-opt="${diets.diet}" >
          <div class="diet-nav-box">
            <img src="${data.image}">
            <span>${diets.diet}</span>
          </div>
          <div class="diet-opt-selectIcon">
            <img class="diet-add-icon" src="https://cdn.shopify.com/s/files/1/0550/7543/8658/files/plus.png?v=1674816491"/>
            <img class="diet-remove-icon" src="https://cdn.shopify.com/s/files/1/0550/7543/8658/files/cross.png?v=1674816519"/>
          </div>
        </li>`;
			}
		});
		return html;
	}

	//recommended diet options
	recommendedDietOptions(diets) {
		console.log(diets);
		if (diets.length > 0) {
			var html = this.getVariantSection(diets, "recommend");
			this.recommendEl.innerHTML = html;

			var _this = this;

			diets.forEach(function (diet) {
				_this.customDietSelected.push({
					diet: diet,
					isSelected: true,
				});
			});
		} else {
			diets = ["wood"];
			var html = this.getVariantSection(diets, "recommend");
			this.recommendEl.innerHTML = html;

			//push diet
			this.customDietSelected.push({
				diet: "wood",
				isSelected: true,
			});
		}
	}

	//Other variant options
	otherVariantsOptions(otherVariants) {
		var html = "",
			_this = this;
		if (otherVariants.length > 0) {
			html = this.getVariantSection(otherVariants);
			this.removeClass(
				".last-step-container .last-step-bottom-section",
				"quiz-step-hide"
			);

			//push other diet in list

			otherVariants.forEach(function (key) {
				if (key != "bag") {
					_this.customDietSelected.push({
						diet: key,
						isSelected: false,
					});
				}
			});
		} else {
			html = "";
			this.addClass(
				".last-step-container .last-step-bottom-section",
				"quiz-step-hide"
			);
		}
		return html;
	}

	//update diet
	udpateDietsVariant(diets) {
		var otherVariants = this.dietOptions.totalDiet.filter((i) => {
			//if diet includes i(diet name) or if diet length 0 and i is not contains "wood"
			return (
				(diets.length == 0 && i != "wood") ||
				(!diets.includes(i) && diets.length > 0)
			);
		});

		//ativated step
		this.menuPdpSelection = diets;
		this.activateDietRows(diets);

		//recommended diet
		this.recommendEl = this.querySelector(".custom-selected-diet");
		if (this.recommendEl) {
			this.recommendedDietOptions(diets);
		}

		//other variant section
		this.otherDiet = this.querySelector(".other-custom-diets");
		if (this.otherDiet) {
			otherVariants.push("bag");
			var html = this.otherVariantsOptions(otherVariants);
			this.otherDiet.innerHTML = html;
		}

		//selected variant Options
		var customDietSelection = this.querySelector(".custom-diet-options");
		if (this.customDietSelected.length > 0 && customDietSelection) {
			var html = this.buildCutomMealNav();
			customDietSelection.innerHTML = html;
		}

		//variant select options
		this.variants = this.querySelectorAll(
			".diet-info-col .check-box input"
		);
	}

	/**
	 *
	 * @returns { "Custom Plan": [] }
	 */
	//variant selection
	variantSelectionBox() {
		var selectedVariant = { "Custom Plan": [], "Cat Name": "" };
		console.warn("here mycode weork");
		if (this.variants.length > 0) {
			this.variants.forEach(function (variant) {
				if (variant.checked && variant.name != "bag") {
					selectedVariant["Custom Plan"].push(variant.name);
				}
			});
		}

		var dogName = this.querySelector("#your-dogs-name");
		if (dogName) {
			selectedVariant["Cat Name"] = dogName.value;
		}

		document.dispatchEvent(
			new CustomEvent("afterAddRemoveCustomDiet", {
				bubbles: true,
				detail: {},
			})
		);

		return selectedVariant;
	}

	//update properties
	updateProperties() {
		var propertyElm = document.querySelectorAll(".product_properties");
		var html = "";

		var variantInfo = this.variantSelectionBox();

		//property
		var propertyList = {
			"Custom Plan": variantInfo["Custom Plan"],
			"Cat Name": variantInfo["Cat Name"],
		};

		//add properties value
		Object.keys(propertyList).forEach(function (property) {
			html += `<input name="properties[${property}]" value="${propertyList[property]}"/>`;
		});

		if (propertyElm.length > 0) {
			propertyElm.forEach(function (property) {
				property && (property.innerHTML = html);
			});
		}
	}

	/**
	 * show and hide diet row
	 */
	activateDietRows(diet) {
		var dietFormRow = this.querySelector(
			'.new-pdp-product-form .product-meal-plan-right[target-prod="wood"]'
		);
		var previous_diet_data = this.getSelectedData();
		//remove active class
		this.removeClass(
			".new-pdp-product-form .product-meal-plan-right.active-meal_form",
			"active-meal_form"
		);
		if (diet.length == 2 && diet.includes("bag")) {
			var _this = this;
			diet.forEach(function (d) {
				if (d != "bag") {
					dietFormRow = _this.querySelector(
						`.new-pdp-product-form .product-meal-plan-right[target-prod="${d}"]`
					);
				}
			});
		} else if (diet.length > 1) {
			dietFormRow = this.querySelector(
				'.new-pdp-product-form .product-meal-plan-right[target-prod="cat-quiz"]'
			);
		} else if (diet.length == 1) {
			dietFormRow = this.querySelector(
				`.new-pdp-product-form .product-meal-plan-right[target-prod="${diet[0]}"]`
			);
		}

		dietFormRow && dietFormRow.classList.add("active-meal_form");
		if (previous_diet_data.diet) {
			this.setClosestVaraintData(previous_diet_data, diet);
		}
	}
	getSingleDietWeightValues() {
		// Initialize a Set to store the unique option values
		let valuesSet = new Set();

		// Select all option elements within the specified selector
		jQuery(
			'.new-pdp-product-form .product-meal-plan-right[target-prod="water"] .your-cats-weight .select__select option'
		).each(function () {
			// Add the value of each option to the Set (duplicates will be ignored)
			valuesSet.add(jQuery(this).val());
		});

		// Convert the Set to an array and return it
		return Array.from(valuesSet);
	}
	getCustomDietWeightValues() {
		// Initialize a Set to store the unique option values
		let valuesSet = new Set();

		// Select all option elements within the specified selector
		jQuery(
			'.new-pdp-product-form .product-meal-plan-right[target-prod="cat-quiz"] .product-form__input--dropdown.cats-weight .select__select option'
		).each(function () {
			// Add the value of each option to the Set (duplicates will be ignored)
			valuesSet.add(jQuery(this).val());
		});

		// Convert the Set to an array and return it
		return Array.from(valuesSet);
	}
	setClosestVaraintData(previous_data, CurrdietData) {
		let dietOptions = this.getDietOptionsToset(previous_data, CurrdietData);
		if (dietOptions.weight) {
			jQuery(
				".product-form__input--dropdown .select__select:visible"
			).val(dietOptions.weight);
			jQuery(
				".product-form__input--dropdown .select__select:visible option"
			)
				.prop("selected", false) // clear existing
				.filter('[value="' + dietOptions.weight + '"]')
				.prop("selected", true);
		}
	}
	getDietOptionsToset(previous_data, CurrDiet) {
		var customDietOptions = this.getCustomDietWeightValues();
		var SingleDietOptions = this.getSingleDietWeightValues();
		console.log("cat custom", customDietOptions);
		console.log("cat sngle", SingleDietOptions);
		var weight = "";
		if (CurrDiet.length > 1) {
			if (!(CurrDiet.length == 2 && CurrDiet.includes("bag"))) {
				weight = this.getClosestRange(
					previous_data.weight,
					customDietOptions
				);
			} else {
				weight = this.getClosestRange(
					previous_data.weight,
					SingleDietOptions
				);
			}
		} else {
			weight = this.getClosestRange(
				previous_data.weight,
				SingleDietOptions
			);
		}
		return { weight };
	}
	getClosestRange(value, ranges) {
		// Function to parse the range and return the min and max
		console.log("cat range", ranges);
		function parseRange(range) {
			let [min, max] = range.split("-").map((str) => {
				// Extract numeric value using regex
				let num = str.match(/\d+/)[0];
				return parseInt(num, 10);
			});
			return { min, max };
		}

		// Parse the value to find
		let valueRange = parseRange(value);

		// Initialize variables to store the closest range and the smallest difference
		let closestRange = null;
		let smallestDifference = Infinity;

		// Iterate over each range in the array
		ranges.forEach((range) => {
			// Parse the current range
			let currentRange = parseRange(range);

			// Calculate the difference between the value range and the current range
			let difference = Math.min(
				Math.abs(valueRange.min - currentRange.min),
				Math.abs(valueRange.max - currentRange.max)
			);

			// Update the closest range if the current difference is smaller than the smallest difference found so far
			if (difference < smallestDifference) {
				closestRange = range;
				smallestDifference = difference;
			}
		});
		if (!closestRange) {
			closestRange = ranges[ranges.length - 1];
		}
		//remove spacing from the closest range
		console.log("test closet", closestRange);
		closestRange = closestRange.replace(" ", "");
		closestRange = closestRange.replace("lbs", "");
		closestRange = closestRange + " " + "lbs";
		// Format the closest range by adding a space before "lbs" if it's not already there
		//closestRange = closestRange.endsWith(' lbs') ? closestRange : closestRange + ' lbs';
		// closestRange = closestRange.endsWith(' lbs') ? closestRange : closestRange + ' lbs';

		// Return the closest range found
		return closestRange;
	}
	/**
	 * Filter diet options based on last quiz step selection
	 */
	filterDietOptions() {
		this.customDietSelected = [];

		//filter diet key
		var diet = this.menuPdpSelection;

		//update diet
		this.udpateDietsVariant(diet);

		//update line property value
		this.updateProperties();
	}

	/**
	 * update diet options
	 */
	updateCustomDietVariants(varientBox, inputElm) {
		//options
		var customElm = this.querySelector(
				".last-step-container .custom-selected-diet"
			),
			otherElm = this.querySelector(
				".last-step-container .other-custom-diets"
			);

		//if variant box not available then return
		if (!varientBox) return;

		//if option checked
		if (inputElm.checked) {
			customElm && customElm.appendChild(varientBox);
		} else {
			otherElm && otherElm.appendChild(varientBox);
		}

		//check and hide section
		var customElmBox = this.querySelectorAll(
				".custom-selected-diet .variety-box"
			),
			otherElmBox = this.querySelectorAll(
				".other-custom-diets .variety-box"
			);

		//custom box
		if (customElmBox.length > 0) {
			if (
				customElmBox.length == 1 &&
				document.querySelector(
					'.last-step-container .last-step-top-section [diet-type="bag"]'
				)
			) {
				this.addClass(
					".last-step-container .last-step-top-section",
					"quiz-step-hide"
				);
			} else {
				this.removeClass(
					".last-step-container .last-step-top-section",
					"quiz-step-hide"
				);
			}
		} else {
			this.addClass(
				".last-step-container .last-step-top-section",
				"quiz-step-hide"
			);
		}

		//other box
		if (otherElmBox.length > 0) {
			this.removeClass(
				".last-step-container .last-step-bottom-section",
				"quiz-step-hide"
			);
		} else {
			this.addClass(
				".last-step-container .last-step-bottom-section",
				"quiz-step-hide"
			);
		}

		//variant options
		this.variants = this.querySelectorAll(
			".diet-info-col .check-box input"
		);

		//checked diet
		var checkedDiets = this.querySelectorAll(
			".diet-info-col .check-box input:checked"
		);
		var diets = [];
		if (checkedDiets.length > 0) {
			checkedDiets.forEach(function (checkdiet) {
				diets.push(checkdiet.name);
			});
		}

		//active diet
		this.activateDietRows(diets);

		//update line property value
		this.updateProperties();
	}

	//event handlers
	dispatchEventHandler() {
		var _this = this;

		//click on diet details show button
		this._liveClickMethod(".diet-detail-button", "click", function () {
			var modalId = this.getAttribute("modal-id"),
				modalContentEl = document.querySelector(
					`.bm-quiz-model #${modalId}-model`
				),
				modalBox = document.querySelector("new-quiz-details-modal");

			if (modalId && modalContentEl) {
				_this.removeClass(
					".bm-quiz-model .model-content",
					"active-modal-content"
				);
				modalContentEl.classList.add("active-modal-content");
				modalBox.classList.add("active-quiz-modal");
			}
		});

		//click on diet add and remove button
		this._liveClickMethod(
			".custom-diet-options .chidog-dite-img",
			"click",
			function () {
				var optType = this.getAttribute("diet-opt");
				var dietOptInput = _this.querySelector(
					`.variety-box[diet-type="${optType}"] .diet-info-col input`
				);

				//dispatch change events
				if (!dietOptInput) return;
				dietOptInput.click();
			}
		);

		//on diet variant change
		this._liveClickMethod(
			".variety-box .diet-info-col input",
			"change",
			function () {
				var varientBox = this.closest(".variety-box"),
					optid = varientBox && varientBox.getAttribute("diet-type"),
					optNavBox = _this.querySelector(
						`.custom-diet-options .chidog-dite-img[diet-opt="${optid}"]`
					);

				//toggle active class
				optNavBox && optNavBox.classList.toggle("active-diet-opt");

				//update variant diet options
				_this.updateCustomDietVariants(varientBox, this);
			}
		);
	}
}
window.customElements.define("new-pdp-step-page", QuizPdpStepPage);

//Quiz last step
class QuizModal extends HTMLElement {
	constructor() {
		super();

		//dispatch eventsTarget
		this.dispatchEventHandler();
	}
	/**
	 * pure functions
	 */
	// live click method
	_liveClickMethod(selector, event, callback, context) {
		// helper for enabling IE 8 event bindings
		function addEvent(el, type, handler) {
			if (el.attachEvent) el.attachEvent("on" + type, handler);
			else el.addEventListener(type, handler);
		}
		// matches polyfill
		this &&
			this.Element &&
			(function (ElementPrototype) {
				ElementPrototype.matches =
					ElementPrototype.matches ||
					ElementPrototype.matchesSelector ||
					ElementPrototype.webkitMatchesSelector ||
					ElementPrototype.msMatchesSelector ||
					function (selector) {
						var node = this,
							nodes = (
								node.parentNode || node.document
							).querySelectorAll(selector),
							i = -1;
						while (nodes[++i] && nodes[i] != node);
						return !!nodes[i];
					};
			})(Element.prototype);
		// live binding helper using matchesSelector
		function _liveClickMethod(selector, event, callback, context) {
			addEvent(context || document, event, function (e) {
				var found,
					el = e.target || e.srcElement;
				while (
					el &&
					el.matches &&
					el !== context &&
					!(found = el.matches(selector))
				)
					el = el.parentElement;
				if (found) callback.call(el, e);
			});
		}
		_liveClickMethod(selector, event, callback, context);
	}
	//remove class
	removeClass(selector, cls) {
		var el = document.querySelectorAll(selector);
		if (el.length > 0) {
			el.forEach(function (item) {
				item.classList.contains(cls) && item.classList.remove(cls);
			});
		}
	}
	//add Class
	addClass(selector, cls) {
		var el = document.querySelector(selector);
		if (el) {
			el.classList.add(cls);
		}
	}

	//event handlers
	dispatchEventHandler() {
		var _this = this;
		this._liveClickMethod(
			"new-quiz-details-modal .bm-quiz-overlay, new-quiz-details-modal .crossmodel",
			"click",
			function (e) {
				_this.classList.contains("active-quiz-modal") &&
					_this.classList.remove("active-quiz-modal");
			}
		);
	}
}
window.customElements.define("new-quiz-details-modal", QuizModal);
